import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { forkJoin, from, of } from 'rxjs';
import { catchError, finalize, last, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { SnackBarItem } from 'src/app/shared/global_components/snack-bar/snack-bar-item';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { BaseClass } from 'src/app/shared/models/base-class';
import { LayoutService } from 'src/app/shared/services/common/layout.service';
import { StorageManagerService } from 'src/app/shared/services/common/storage-manager.service';
import { AuthService } from 'src/app/shared/services/rest/auth.service';
import { CompanyService } from 'src/app/shared/services/rest/company.service';
import { environment } from 'src/environments/environment';
import { MY_FORMATS } from 'src/app/components/atTasksDialog/task-profile-add/task-profile-add.component';
import { LanguageService } from 'src/app/shared/services/common/language.service';
import { NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { LoadingService } from 'src/app/shared/services/rest/loading.service';
import * as moment from 'moment';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'app-create-regulars-for-group-channels',
  templateUrl: './create-regulars-for-group-channels.component.html',
  styleUrls: ['./create-regulars-for-group-channels.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class CreateRegularsForGroupChannelsComponent extends BaseClass implements OnInit, OnDestroy {
  public host: any = environment.host;
  public imgRoute: any = '';
  public user: any = {};
  public activeLang: any;
  public user_id: number;
  public hhMin: FormControl = new FormControl(0);
  public hhMax: FormControl = new FormControl(24);
  public mmMin: FormControl = new FormControl(0);
  public mmMax: FormControl = new FormControl(60);
  public form: FormGroup;
  public company_id: any;
  public page: number = 1;
  public isSubmit: boolean = false;
  public isFormChange: boolean = false;
  public platforms: any;
  public contentTypes: any;
  public channelsToGroup: any;
  public types:any = ['is_daily', 'is_weekly', 'is_monthly']
  public weekDays = new Array(7)
  public monthDays = new Array(31)
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CreateRegularsForGroupChannelsComponent>,
    private layoutService: LayoutService,
    private languageService: LanguageService,
    private _ngx_adapter: NgxMatDateAdapter<any>,
    private sm: StorageManagerService,
    private auth: AuthService,
    private companyService: CompanyService,
    private ls: LoadingService,
    private fb: FormBuilder,
  ) { super() }

  ngOnInit(): void {
    console.log("CreateRegularsForGroupChannelsComponent", this.data)
    this.getCompany();
    this.getImgRoute();
    this.getLangData();
    this.getCsrf();
    this.getUser();
    this.getPlatforms();
    this.getContentTypes();
    this.getChannelsToGroup();



    this.form = this.fb.group({
      name: ['{Outlet} regular', Validators.required],
      regName: ['{Outlet} regular slot {index}', Validators.required],
      type: [0, Validators.required],
      apply_from_time: ['', Validators.required],
      apply_to_time: ['', Validators.required]
    })

    this.attachSubscriptions(
      this.form.valueChanges.subscribe(() => {
        this.isFormChange = true

        this.channelsToGroup.forEach(element => {
          element.form = {...this.form.value};
          element.form.name = element.form.name.replaceAll('{Outlet}', element.channel.name)

          if (element.slots) {
            element.slots.forEach((slot, index) => {
              slot.name = element.form.regName.replaceAll('{Outlet}', element.channel.name).replaceAll('{index}', index+1)
            });
          }
        });
      })
    )

    this.attachSubscriptions(
      this.dialogRef.backdropClick().subscribe(e => {
        e.preventDefault();
        if (this.isFormChange) {
          this.layoutService.openBottomSheet(this.dialogRef);
        } else {
          this.close();
        }
      })
    )
  }

  
  getLangData() {
    this.attachSubscriptions(
      this.languageService.getLangData().subscribe(resp => {
        this.activeLang = resp.active;
        this._ngx_adapter.setLocale(resp.active);
      })
    )
  }

  getContentTypeById(id) {
    if (!this.contentTypes || this.contentTypes.filter(el => el.id == id).length == 0) {
      return false;
    }
    return this.contentTypes.find(el => el.id == id)
  }

  getContentTypes() {
    this.attachSubscriptions(
      this.companyService.getContentTypes(null, '1').pipe(
        map(el => el.body)
      ).subscribe(resp => {
        this.contentTypes = resp;
        console.log("getContentTypes", this.contentTypes)
      })
    )
  }

  getTypesByPlatform(id) {
    if (!this.contentTypes || this.contentTypes.filter(el => el.platform_id == id).length == 0) {
      return false;
    }
    return this.contentTypes.filter(el => el.platform_id == id)
  }

  getPlatformById(id) {
    if (!this.platforms || this.platforms.filter(el => el.id == id).length == 0) {
      return false;
    }
    return this.platforms.find(el => el.id == id)
  }

  getPlatforms() {
    this.attachSubscriptions(
      this.companyService.getGroupPlatforms().subscribe(resp => {
        this.platforms = resp;
      })
    )
  }

  getChannelsToGroup() {
    this.attachSubscriptions(
      this.companyService.getChannelsToGroup(this.data.company.id, {group_id: this.data.group.id}).pipe(
        map(el => el.body),
        tap(arr => {
          console.log(arr)
          arr.forEach(element => {
            element.form = {
              name: `${element.channel.name} regular`,
              regName: `${element.channel.name} regular slot {index}`,
              type: 0,
              apply_from_time: '',
              apply_to_time: ''
            }
          });
        })
      ).subscribe(resp => {
        console.log("getChannelsToGroup channelsToGroup", resp)
        this.channelsToGroup = resp
      })
    )
  }

  getCompany() {
    this.attachSubscriptions(
      this.companyService.getCompany(this.data.company_id).subscribe(resp => {
        this.companyService.company$.next(resp[0]);
      })
    )
  }

  getImgRoute() {
    this.attachSubscriptions(
      this.sm.getImgPath().subscribe(el => {
        this.imgRoute = el;
      })
    )
  }

  getCsrf() {
    this.attachSubscriptions(
      this.auth.$userToken.subscribe(resp => {
        this.user_id = resp.user_id;
        this.sm.localStorageSetItem("csrf_param", resp.csrf_param)
        this.sm.localStorageSetItem("csrf_token", resp.csrf_token)
      })
    )
  }

  getUser() {
    this.attachSubscriptions(
      this.auth.$user.subscribe(resp => {
        this.user = resp;
      })
    )
  }

  log() {
    console.log('form', this.form.value)
    console.log('this.channelsToGroup', this.channelsToGroup)
  }

  addSlot(item?) {
    if (item) {

      let newItem:any = {
        company_id: item.company_id, 
        content_schedule_id: item.id, 
        name: item.form.regName.replaceAll('{Outlet}', item.channel.name),
        time: 3600
      }
      if (item.form.type != 0) {
        newItem.day_number = 1
      }

      if (item.slots) {
        newItem.name = newItem.name.replaceAll('{index}', `${item.slots.length + 1}`);
        item.slots.push({...newItem})
      } else {
        newItem.name = newItem.name.replaceAll('{index}', '1')
        item.slots = [{...newItem}]
      }
    } else {
      this.channelsToGroup.forEach(reg => {
        let newItem:any = {
          company_id: reg.company_id, 
          content_schedule_id: reg.id, 
          name: reg.form.regName.replaceAll('{Outlet}', reg.channel.name),
          time: 3600
        }
        if (reg.form.type != 0) {
          newItem.day_number = 1
        }
        if (reg.slots) {
          newItem.name = newItem.name.replaceAll('{index}', `${reg.slots.length + 1}`);
          reg.slots.push({...newItem})
        } else {
          newItem.name = newItem.name.replaceAll('{index}', '1')
          reg.slots = [{...newItem}]
        }
      });
    }
  }

  shuffleTime(t: 'h' | 'm', min?: number, max?: number, slot?:any) {
    // Установка дефолтных границ
    const defaults = {
      h: { min: 0, max: 24 },
      m: { min: 0, max: 60 }
    };

    // Безопасно привести к числу
    min = Number(min);
    max = Number(max);

    if (isNaN(min) || min < 0 || (t === 'h' && min > 23) || (t === 'm' && min > 59)) {
      min = defaults[t].min;
    }
    if (isNaN(max) || max < 0 || (t === 'h' && max > 23) || (t === 'm' && max > 59)) {
      max = defaults[t].max;
    }
    if (min > max) {
      [min, max] = [max, min]; // Переставляем, если min > max
    }

    const getRandom = (min: number, max: number) =>
      Math.floor(Math.random() * (max - min + 1)) + min;


    if (slot) {
      if (!slot.timeInFormat) {
        slot.timeInFormat = "00:00"
      }
      const [hhStr, mmStr] = slot.timeInFormat.split(':');
      let hh = parseInt(hhStr, 10);
      let mm = parseInt(mmStr, 10);

      if (isNaN(hh)) hh = 0;
      if (isNaN(mm)) mm = 0;

      if (t === 'h') {
        hh = getRandom(min, max);
      } else {
        mm = getRandom(min, max);
      }

      // Приводим к формату "HH:mm"
      slot.timeInFormat = `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
    } else {
      this.channelsToGroup.forEach(element => {
        element.slots?.forEach(slot => {
          if (!slot.timeInFormat) {
            slot.timeInFormat = "00:00"
          }
  
          const [hhStr, mmStr] = slot.timeInFormat.split(':');
          let hh = parseInt(hhStr, 10);
          let mm = parseInt(mmStr, 10);
  
          if (isNaN(hh)) hh = 0;
          if (isNaN(mm)) mm = 0;
  
          if (t === 'h') {
            hh = getRandom(min, max);
          } else {
            mm = getRandom(min, max);
          }
  
          // Приводим к формату "HH:mm"
          slot.timeInFormat = `${String(hh).padStart(2, '0')}:${String(mm).padStart(2, '0')}`;
        });
      });
    }
  }

  removeSlot(item, slotInd) {
    item.slots.splice(slotInd, 1);
  }

  deleteRow(j) {
    this.channelsToGroup.splice(j,1)
  }

  onSubmit() {
    this.isSubmit = true;

    let count = 0;
    let lenSelection = this.channelsToGroup.length;

    if (!lenSelection) {
      this.layoutService.showSnackBar({name: 'There is no media from the selected files from which audio can be exported.'}, '', SnackBarItem)
      return
    }

    this.ls.requests$.next({
      value: 0,
      target: `Creating Regulars for ${lenSelection} Channels`
    })


  //     addRegularItem(regular) {
  //   console.log(regular)
  //   let newItem:any = {
  //     company_id: this.company_id, 
  //     content_schedule_id: regular.id, 
  //     name: "New regular publication",
  //     time: 3600
  //   }
  //   if (!regular.is_daily) {
  //     newItem.day_number = 1
  //   }
  //   this.attachSubscriptions(
  //     this.companyService.addRegularItem(newItem).subscribe(resp => {
  //       regular.items.push(resp)
  //       this.focusValue(regular, resp)
  //     })
  //   )
  // }
    from(this.channelsToGroup).pipe(
      mergeMap((chToGroup:any) => {
        let sbmtData:any = {
          company_id: chToGroup.company_id,
          name: chToGroup.form.name,
          channel_id: chToGroup.channel_id,
          content_type_id: chToGroup.content_type_id,
          group_id: chToGroup.channel_group_id
        }
        if (!!chToGroup.form.apply_from_time && !!chToGroup.form.apply_from_time._d) {
          sbmtData.apply_from_time = moment(chToGroup.form.apply_from_time._d).utc().format("X");
        }
    
        if (!!chToGroup.form.apply_to_time && !!chToGroup.form.apply_to_time._d) {
          sbmtData.apply_to_time = moment(chToGroup.form.apply_to_time._d).utc().format("X");
        } 

        sbmtData[this.types[chToGroup.form.type]] = 1
    
        // delete sbmtData.type;
        return this.companyService.addRegular(sbmtData)
        .pipe(
          switchMap(el => {
            if (chToGroup.slots && chToGroup.slots.length) {
              return forkJoin(chToGroup.slots.map(slot => {
                let newItem:any = {...slot};
                if (!newItem.timeInFormat) {
                  newItem.timeInFormat == "00:00"
                }
                newItem.content_schedule_id = el.id;
                newItem.time = Number(newItem.timeInFormat.split(":")[0])*3600 + Number(newItem.timeInFormat.split(":")[1])*60;

                if (chToGroup.form.type == 0) {
                  delete newItem.day_number;
                } else {
                  if (!newItem.day_number) {
                    newItem.day_number = 1;
                  }
                }

                return this.companyService.addRegularItem(newItem)
              }))
            } else {
              return of(el)
            }
          }),
          catchError(() => of([])),
          tap(() => {
            this.ls.requests$.next({
              value: Math.round((100 / lenSelection) * (count+1)),
              target: `Creating Regulars for ${lenSelection} Channels`
            })
            count++;
          })
        )
      }, 10), // 4 запроса параллельно
      finalize(() => {
        this.layoutService.showSnackBar({name: `Creating Regulars for ${lenSelection} Channels`}, marker("successfully!"), SnackBarItem)
        // Этот блок выполнится только после обработки всех элементов
        console.log('Все запросы завершены');
        // Здесь можно дополнительно обработать card.is_ok_tags или другие поля
      }),
      last()
    ).subscribe(resp => {
      this.isSubmit = false;
      this.dialogRef.close({event: "update", data: resp});
    }, error => {
      this.isSubmit = false;
      this.layoutService.showSnackBar({name: ''}, error, SnackBarItem)
    })
  }

  close() {
    this.dialogRef.close({event: "close", data: false})
  }

  ngOnDestroy(): void {
    this.clearSubscriptions();
  }
}
